import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataNotFound from "../../../../components/Data Not Found";
import Pagination from "../../../../components/Pagination";
import DeleteModal from "../../../../components/Trashed Modal/DeleteModal";
import CalendarFilter from "../../../../Filters/CalendarFilter";
import useLoading from "../../../../hooks/useLoading";
import {
  getExpense,
  restoreExpense,
} from "../../../../lib/api functions/expense";
import { showToast } from "../../../../lib/toast/ShowToast";
import ShowSelectedDate from "../../../../shared components/DateInput/ShowSelectedDate";
import SkeletonLoader from "../../../../shared components/Loader/SkeletonLoader";
import Search from "../../../../shared components/Search";
import {
  DELETE_EXPENSE_HARD,
  invoiceStatussMap,
} from "../../../../utils/constants";
import { MainContext } from "../../../../utils/private_routes/PrivateRoutes";
import { commonType } from "../../lead";
import { ParamType } from "./../type";

const TrashedExpense = () => {
  const { setPageTitle, userId, companyId, roles, setting } =
    useContext(MainContext);
  const [commonData, setCommonData] = useState<commonType>({
    data: undefined,
    modal: false,
    check: "",
  });
  const navigate = useNavigate();
  const [loading, showLoader, hideLoader] = useLoading();
  const [expenses, setExpenses] = useState<any>([]);
  const [totalResult, setTotalResult] = useState<number>(0);

  const [params, setParams] = useState<ParamType>({
    page: 1,
    per_page: 10,
    company: companyId,
    isDeleted: true,
  });

  const fn = {
    openModal: (data?: any, check?: string) => {
      setCommonData({
        data: data,
        modal: true,
        check: check,
      });
      document.body.style.overflow = "hidden";
    },
    getExpenses: async (params?: ParamType) => {
      showLoader();
      const res = await getExpense(params);
      if (res) {
        setExpenses(res.data.expenses);
        setTotalResult(res.data.total);
        hideLoader();
      }
    },
    restoreExpense: async (expenseId: string) => {
      let finalObj = {
        expenseIds: [expenseId],
        isDeleted: false,
      };
      const res = await restoreExpense(finalObj, hideLoader);
      if (res) {
        showToast(`Expense Restored`, "success");
        fn.getExpenses(params);
      }
    },
  };

  useEffect(() => {
    if (roles?.length !== 0) {
      if (!roles[0]?.expenses.complete) {
        params.user = userId;
        fn.getExpenses(params);
      } else {
        fn.getExpenses(params);
      }
    }
  }, []);

  useEffect(() => {
    setPageTitle("Trashed Expense");
  }, []);

  return (
    <>
      <div className="single_page">
        <div className="data_render_wrapper">
          {/* filters */}
          <div className="filter_wrapper">
            <div className="container-fluid p-0">
              <div className="row align-items-center">
                <div className="col-12 col-lg-4">
                  <Search
                    placeholder="Search by doc number"
                    state={params}
                    setState={setParams}
                    apiCall={fn.getExpenses}
                    paramValue="number"
                  />
                </div>
                <div className="col-12 col-lg-8 pt-3 pt-lg-0">
                  <div className="d-flex align-items-center gap-3 justify-content-start justify-content-lg-end">
                    {params?.dF && (
                      <>
                        <ShowSelectedDate
                          label="From:"
                          value={moment(params?.dF?.split("_")[1]).format(
                            setting?.dateFormat
                          )}
                        />
                        <ShowSelectedDate
                          label="To:"
                          value={moment(params?.dF?.split("_")[2]).format(
                            setting?.dateFormat
                          )}
                        />
                      </>
                    )}

                    <div className="d-flex gap-2">
                      <CalendarFilter
                        state={params}
                        apiCall={fn.getExpenses}
                        setState={setParams}
                        fieldName="date"
                        label="Issue date"
                        isFutureDateRequired={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="list_view_wrapper">
            <div className="container-fluid p-0">
              <div className="row align-items-center pb-3">
                <div className="col-12 col-lg-3">
                  <span className="font16x600 textColor3">
                    List of Trashed Expenses
                  </span>
                </div>
              </div>
            </div>

            {/* table */}
            {expenses?.length !== 0 ? (
              <div className="entry_table_wrapper">
                <div className="table_wrapper">
                  <table className="table">
                    <thead className="table_head">
                      <tr className="font12x500 textColor3">
                        <th scope="col">#</th>
                        <th scope="col">Issue Date</th>
                        <th scope="col">Due Date</th>
                        <th scope="col">Doc No</th>
                        <th scope="col">Vendor Name</th>
                        <th scope="col">Tax</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Balance</th>
                        <th scope="col">Status</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expenses?.map((expense: any, i: number) => {
                        return (
                          <tr key={i} className="font12x400">
                            <th>
                              {(params.page - 1) * params.per_page + (i + 1)}
                            </th>
                            <td>
                              {moment(expense?.date).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>
                              {moment(expense?.dueDate).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>{expense?.number}</td>
                            <td>{expense?.vendor?.name}</td>
                            <td>{`₹ ${(
                              expense?.calculation?.cgst +
                              expense?.calculation?.sgst +
                              expense?.calculation?.igst
                            )?.toLocaleString()}`}</td>
                            <td>{`₹ ${expense?.calculation?.total?.toLocaleString()}`}</td>
                            <td>{`₹ ${(
                              expense?.calculation?.total - expense?.paidAmount
                            )?.toLocaleString()}`}</td>
                            <td className="font12x500">
                              {invoiceStatussMap.get(expense?.status)}
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-3">
                                <button
                                  className="btn font12x500 buttonTwo shadow-none"
                                  onClick={() =>
                                    fn.restoreExpense(expense?._id)
                                  }
                                >
                                  Restore
                                </button>
                                <div
                                  className="cursor_pointer"
                                  onClick={() =>
                                    fn.openModal(
                                      { expenseIds: [expense?._id] },
                                      "delete"
                                    )
                                  }
                                >
                                  <img
                                    src="/Assets/Svg/deleteColor.svg"
                                    alt="close"
                                    className="img-fluid"
                                    draggable={false}
                                  />
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : loading ? (
              <SkeletonLoader />
            ) : (
              <DataNotFound />
            )}
          </div>
        </div>

        {/* pagination */}
        {expenses?.length !== 0 && (
          <div className="pagination_wrapper pt-3 px-3">
            <Pagination
              currentPage={params.page}
              onPageChange={(e) => {
                fn.getExpenses({ ...params, page: e });
                setParams({
                  ...params,
                  page: e,
                });
              }}
              pageSize={params.per_page}
              totalCount={Math.ceil(totalResult / params.per_page)}
              onChangePerPage={(e) => {
                fn.getExpenses({ ...params, per_page: e });
                setParams({
                  ...params,
                  per_page: e,
                });
              }}
            />
          </div>
        )}
      </div>

      {/* delete modal */}
      {commonData?.modal && commonData?.check === "delete" && (
        <DeleteModal
          label="Expense"
          dataIds={commonData?.data}
          setState={setCommonData}
          url={DELETE_EXPENSE_HARD}
          variableName="expenseIds"
          apiCall={fn.getExpenses}
          params={params}
        />
      )}
    </>
  );
};

export default TrashedExpense;
